export const manageMyAccountData = [
  {
    Question: `How do I manage my account?`,
    Answer: `Managing your account(s), including name, email, password and billing information online is easy. 

        Visit our expanded knowledge repository on Link insertion: <a href=’https://www.wm.com/us/en/support/faqs/account#manage-accounts’>account management</a> to explore all the ways you can manage your account.  
        
        Your My WM account now makes it more convenient than ever to: 
        
        <ul><li>Enjoy the convenience of 24 hour access</li> 
        
        <li> Download invoices </li> 
        
        <li> Pay your bill online </li> 
        
        <li> Change or edit your notification preferences </li> 
        
        <li> Update your password or billing address </li> </ul>`,
  },
]
